import * as iconsList from '@nxsys/components/AppIconSvg';

export type AppIconType = keyof typeof iconsList;

export type IconProps = {
  height?: number;
  width?: number;
  color?: string;
};

export const Icons = iconsList as Record<
  AppIconType,
  React.MemoExoticComponent<(props?: IconProps) => React.JSX.Element>
>;
